<template>
  <footer class="bg-main_black text-white py-8">
    <div class="container mx-auto px-4">
      <!-- Logo & Navigation Links -->
      <div class="flex flex-col md:flex-row justify-between items-center mb-6 text-center md:text-left">
        <div class="flex items-center justify-center md:justify-start mb-4 md:mb-0">
          <img 
            src="../assets/icons/hutu-abuja.png" 
            :alt="getTranslation('footer.logoAlt', 'Hutu Abuja')" 
            class="h-12" 
          />
        </div>
        <div class="flex flex-wrap justify-center md:justify-end space-x-4 md:space-x-6">
          <div v-for="(link, index) in navigationLinks" :key="index">
            <span class="text-gray-500 hidden md:inline">•</span>
            <a href="#" class="hover:text-gray-300">
              {{ link.key }}
            </a>
          </div>
        </div>
      </div>
      
      <!-- Contact Info -->
      <div class="flex flex-col md:flex-row justify-between items-center py-6 border-t border-b border-gray-800 text-center md:text-left">
        <div class="mb-4 md:mb-0">
          <a href="mailto:info@greenlightmusicpub.com" class="hover:text-gray-300">
            info@mshelconstruction.com
          </a>
        </div>
        <div class="flex flex-wrap justify-center md:justify-end space-x-2">
          <a href="tel:+2348104215500" class="hover:text-gray-300">
            {{ getTranslation('footer.contact.phone1', '+2348104215500') }}
          </a>,
          <a href="tel:+2348038067486" class="hover:text-gray-300">
            {{ getTranslation('footer.contact.phone2', '+2348038067486') }}
          </a>
        </div>
      </div>
      
      <!-- Copyright, Policies, and Social Links -->
      <div class="flex flex-col md:flex-row justify-between items-center mt-6 text-center md:text-left">
        <div class="mb-4 md:mb-0">
          © 2025. Mshel Construction Limited
        </div>
        <div class="flex flex-wrap justify-center md:justify-end space-x-4 md:space-x-6">
          <a href="#" class="hover:text-gray-300">
            {{ getTranslation('footer.policies.privacy', 'Privacy Policy') }}
          </a>
          <span class="text-gray-500 hidden md:inline">•</span>
          <a href="#" class="hover:text-gray-300">
            {{ getTranslation('footer.policies.terms', 'Terms and conditions') }}
          </a>
          <span class="text-gray-500 hidden md:inline">•</span>
          <a href="#" class="hover:text-gray-300">
            {{ getTranslation('footer.policies.support', 'Support') }}
          </a>
        </div>
        <div class="flex justify-center md:justify-end space-x-4 mt-4 md:mt-0">
          <a href="#" class="hover:text-gray-300">
            <img 
              src="../assets/icons/instagram.svg" 
              :alt="getTranslation('footer.social.instagram', 'Instagram')" 
              class="h-5" 
            />
          </a>
          <a href="#" class="hover:text-gray-300">
            <img 
              src="../assets/icons/x.svg" 
              :alt="getTranslation('footer.social.twitter', 'Twitter')" 
              class="h-5" 
            />
          </a>
          <a href="#" class="hover:text-gray-300">
            <img 
              src="../assets/icons/tiktok.svg" 
              :alt="getTranslation('footer.social.tiktok', 'TikTok')" 
              class="h-5" 
            />
          </a>
          <a href="#" class="hover:text-gray-300">
            <img 
              src="../assets/icons/facebook.svg" 
              :alt="getTranslation('footer.social.facebook', 'Facebook')" 
              class="h-5" 
            />
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterComponent',
  data() {
    return {
      navigationLinks: [
        { key: 'home', fallback: 'Home' },
        { key: 'services', fallback: 'Services' },
        { key: 'projects', fallback: 'Projects' },
        { key: 'about', fallback: 'About' }, 
      ]
    };
  },
  methods: {
    getTranslation(key, fallback) {
      try {
        // Check if $t function exists (i18n is available)
        if (this.$t && typeof this.$t === 'function') {
          const translation = this.$t(key);
          // If translation returns the key itself, it means translation is missing
          return translation !== key ? translation : fallback;
        }
        return fallback;
      } catch (error) {
        console.warn(`Translation error for key: ${key}`, error);
        return fallback;
      }
    }
  }
};
</script>

<style scoped>
/* Additional styles if needed */
</style>